<template>
  <NuxtLoadingIndicator color="#a10009" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup></script>
